import Preview from "./Preview/Preview";


export default {
    id:"PopupView",
    parent:{name:"View"},
    description:"a self-position-adjustment view",
    preview:Preview,
    props:[
        {
            name:"target",
            type:"HTMLElement",
            description:"an element near which the popupview is shown",
        },
        {
            name:"parent",
            type:"HTMLElement",
            description:`
                if target is specified, parent is the element relative to which the PopupView will adjust its position 
                @default document.documentElement
            `,
        },
        {
            name:"avoidable",
            type:"boolean",
            defaultValue:true,
            description:"unmounts the popupview on outside click",
        },
        {
            name:"offset",
            type:`{x:number,y:number}`,
            description:"popup offset relative to target",
        },
        {
            name:"onRemove",
            type:"():void",
        },
    ],
    methods:[
        {
            name:"position",
            type:"():void",
            description:"updates the PopupView position",
        },
        {
            name:"unmount",
            type:"():void",
            description:"removes the PopupView from the DOM with a fade-out animation",
        },
    ],
}
